import { createWithEqualityFn } from 'zustand/traditional';

type ToastStore = {
  persistToast: boolean;

  enablePersistToast: () => void;
  clearPersistToast: () => void;
};

const initialState = {
  persistToast: false,
};

export const useToastStore = createWithEqualityFn<ToastStore>()((set) => ({
  ...initialState,
  enablePersistToast: () =>
    set(() => ({
      persistToast: true,
    })),
  clearPersistToast: () =>
    set(() => ({
      persistToast: false,
    })),
}));
